<template>
    <div>
      <!-- Header -->
      <header class="bg-primary text-white text-center py-5 position-relative overflow-hidden">
        <h1 class="fw-semibold display-5">Privacy Policy</h1>
        <p class="mt-2 fs-6">Effective May 1, 2025</p>
        <svg
          class="position-absolute bottom-0 start-0 w-100"
          viewBox="0 0 1440 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0 0C240 120 480 120 720 120C960 120 1200 120 1440 0V120H0V0Z"
            fill="white"
          />
        </svg>
      </header>
  
      <!-- Main Content -->
      <main class="container my-5">
        <div class="row">
          <!-- Navigation -->
          <nav class="col-md-4 mb-4 mb-md-0">
            <ul class="list-group">
              <li class="list-group-item bg-success"><a href="#intro" class="text-decoration-none text-white">1. Introduction</a></li>
              <li class="list-group-item bg-success"><a href="#info" class="text-decoration-none text-white">2. Information We Collect</a></li>
              <li class="list-group-item bg-success"><a href="#usage" class="text-decoration-none text-white">3. How We Use Your Information</a></li>
              <li class="list-group-item bg-success"><a href="#security" class="text-decoration-none text-white">4. Data Security</a></li>
              <li class="list-group-item bg-success"><a href="#sharing" class="text-decoration-none text-white">5. Sharing Your Information</a></li>
              <li class="list-group-item bg-success"><a href="#cookies" class="text-decoration-none text-white">6. Cookies and Tracking</a></li>
              <li class="list-group-item bg-success"><a href="#rights" class="text-decoration-none text-white">7. Your Rights</a></li>
              <li class="list-group-item bg-success"><a href="#updates" class="text-decoration-none text-white">8. Updates</a></li>
              <li class="list-group-item bg-success"><a href="#contact" class="text-decoration-none text-white">9. Contact Us</a></li>
            </ul>
          </nav>
  
          <!-- Policy Section -->
          <section class="col-md-8">
            <div class="mb-4" id="intro">
              <h2 class="h5 fw-bold">1. Introduction</h2>
              <p>
                At Wasiyah.com (“we,” “us,” “our”), we value and respect the privacy of our users and are committed to protecting the confidentiality and security of your personal data. This Privacy Policy outlines how we collect, use, store, and disclose your information when you access our website (www.wasiyah.com) and mobile application (the “Al-wasiyah”). By using our Platform, you agree to the terms set forth in this Privacy Policy.
              </p>
            </div>
  
            <div class="mb-4" id="info">
              <h2 class="h5 fw-bold">2. Information We Collect</h2>
              <p>To provide our services, including the Zakat Calculation feature, we collect various types of information, which may include:</p>
              <ul>
                <li><strong>Personal Information:</strong> Name, email address, phone number, and other personal details.</li>
                <li><strong>Financial Information:</strong> Cash holdings, bank balances, precious metals, investment assets.</li>
                <li><strong>Nominee Information:</strong> Beneficiary details for your Wasiyah.</li>
                <li><strong>Usage Data:</strong> IP address, browser type, device info, interaction logs.</li>
                <li><strong>Location Data:</strong> If enabled, for localized services like prayer reminders or Zakat info.</li>
              </ul>
            </div>
  
            <div class="mb-4" id="usage">
              <h2 class="h5 fw-bold">3. How We Use Your Information</h2>
              <ul>
                <li>To draft and manage your Wasiyah in line with Islamic law.</li>
                <li>To calculate Zakat obligations using your financial data.</li>
                <li>To send notifications about services such as prayer times and reminders.</li>
                <li>To process donations and secure payments.</li>
                <li>To improve our platform and tailor user experience.</li>
              </ul>
            </div>
  
            <div class="mb-4" id="security">
              <h2 class="h5 fw-bold">4. Data Security</h2>
              <p>
                We implement encryption and secure servers to protect your personal and financial information. However, no system is fully secure, and we cannot guarantee absolute protection.
              </p>
            </div>
  
            <div class="mb-4" id="sharing">
              <h2 class="h5 fw-bold">5. Sharing Your Information</h2>
              <ul>
                <li><strong>Service Providers:</strong> Third-party vendors like payment processors and hosting services.</li>
                <li><strong>Legal Compliance:</strong> If legally required, such as court orders or legal processes.</li>
                <li><strong>Business Transactions:</strong> In cases of mergers, acquisitions, or sales of assets.</li>
              </ul>
            </div>
  
            <div class="mb-4" id="cookies">
              <h2 class="h5 fw-bold">6. Cookies and Tracking Technologies</h2>
              <p>
                We use cookies to enhance your experience. You can manage cookie settings in your browser, though disabling them may impact functionality.
              </p>
            </div>
  
            <div class="mb-4" id="rights">
              <h2 class="h5 fw-bold">7. Your Rights</h2>
              <ul>
                <li><strong>Access:</strong> Request a copy of your personal data.</li>
                <li><strong>Correction:</strong> Update or fix inaccuracies in your data.</li>
                <li><strong>Deletion:</strong> Request account deletion (subject to legal obligations).</li>
                <li><strong>Objection:</strong> Oppose processing in certain cases.</li>
                <li><strong>Portability:</strong> Request data transfer to another provider.</li>
              </ul>
              <p>To exercise your rights, contact us at <a href="mailto:contact@wasiyah.com">contact@wasiyah.com</a>.</p>
            </div>
  
            <div class="mb-4" id="updates">
              <h2 class="h5 fw-bold">8. Updates to this Privacy Policy</h2>
              <p>
                We may periodically update this Privacy Policy. Changes will appear on this page with a revised date. Please check it regularly.
              </p>
            </div>
  
            <div class="mb-4" id="contact">
              <h2 class="h5 fw-bold">9. Contact Us</h2>
              <p>If you have questions or concerns regarding this Privacy Policy, please contact us at:</p>
              <p>Email: <a href="mailto:contact@wasiyah.com">contact@wasiyah.com</a></p>
            </div>
          </section>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  export default {
    name: "PrivacyPolicy",
  };
  </script>
  
  <style scoped>
  header {
    /* background: linear-gradient(to right, #3B2E99, #2E2A7E); */
    background: #077747 !important;
  }
  section {
  text-align: left;  /* Force left alignment on the entire section */
}

section h2, section p, section ul, section li {
  text-align: left;  /* Make sure all titles, paragraphs, and list items align left */
  margin-left: 0;
  line-height: 1.6;
}
  </style>
  